(function(){
  var FAVORITES_SIDE_KEY='dkWishSide';
  var FAVORITES_TOP_KEY='dkWishTop';

  /* El componente draggable antiguo se registró antes. Este lock se ejecuta
     como script defer antes de DOMContentLoaded y evita que vuelva a recolocar
     el botón al navegar o refrescar. */
  function lockLegacyDrag(tab){
    if(!tab) return;
    tab.dataset.dkDrag='2';
    tab.classList.remove('dk-side-right','is-dragging');
    tab.classList.add('dk-side-left');
    try{
      localStorage.setItem(FAVORITES_SIDE_KEY,'left');
      localStorage.removeItem(FAVORITES_TOP_KEY);
    }catch(e){}
  }

  function enableVerticalDrag(tab){
    var state=null, suppressUntil=0;
    function key(){return window.matchMedia('(max-width:749px)').matches?'dkWishVerticalMobileV1':'dkWishVerticalDesktopV1';}
    function height(){return window.innerHeight;}
    function clamp(y){return Math.max(44,Math.min(height()-96,y));}
    function restore(){
      if(state)return;
      var saved=null;try{saved=localStorage.getItem(key());}catch(e){}
      var ratio=Number(saved);
      if(saved!==null&&isFinite(ratio)&&ratio>=0&&ratio<=1)tab.style.setProperty('--dk-favorites-top',clamp(ratio*height())+'px');
      else tab.style.removeProperty('--dk-favorites-top');
    }
    tab.style.setProperty('touch-action','none','important');
    tab.style.setProperty('user-select','none','important');
    tab.style.setProperty('cursor','grab','important');
    tab.setAttribute('title','Favoritos: arrastra para mover; toca para abrir');
    tab.addEventListener('pointerdown',function(ev){
      if(!ev.isPrimary||(ev.pointerType==='mouse'&&ev.button!==0))return;
      ev.stopImmediatePropagation();
      var r=tab.getBoundingClientRect();
      state={id:ev.pointerId,start:ev.clientY,center:r.top+r.height/2,moved:false,key:key()};
      try{tab.setPointerCapture(ev.pointerId);}catch(e){}
    },true);
    tab.addEventListener('pointermove',function(ev){
      if(!state||ev.pointerId!==state.id)return;
      var delta=ev.clientY-state.start;
      if(!state.moved&&Math.abs(delta)<6)return;
      state.moved=true;ev.preventDefault();ev.stopImmediatePropagation();
      tab.style.setProperty('cursor','grabbing','important');
      tab.style.setProperty('--dk-favorites-top',clamp(state.center+delta)+'px');
    },true);
    function finish(ev){
      if(!state||ev.pointerId!==state.id)return;
      var drag=state;state=null;
      if(drag.moved){
        suppressUntil=Date.now()+500;ev.preventDefault();ev.stopImmediatePropagation();
        var y=parseFloat(tab.style.getPropertyValue('--dk-favorites-top'));
        try{localStorage.setItem(drag.key,String(y/height()));}catch(e){}
        window.dispatchEvent(new Event('resize'));
      }
      tab.style.setProperty('cursor','grab','important');
      try{tab.releasePointerCapture(ev.pointerId);}catch(e){}
    }
    tab.addEventListener('pointerup',finish,true);
    tab.addEventListener('pointercancel',finish,true);
    tab.addEventListener('lostpointercapture',function(){state=null;tab.style.setProperty('cursor','grab','important');});
    tab.addEventListener('click',function(ev){if(Date.now()<suppressUntil){ev.preventDefault();ev.stopImmediatePropagation();}},true);
    window.addEventListener('resize',restore);
    restore();
  }

  function stabilizeFavorites(){
    var tab=document.getElementById('wishTab');
    if(!tab) return;
    lockLegacyDrag(tab);
    if(tab.dataset.dkStable20261003!=='1'){
      tab.dataset.dkStable20261003='1';
      tab.classList.add('dk-wish-load-ready');
      tab.style.setProperty('left','0px','important');
      tab.style.setProperty('right','auto','important');
      tab.style.setProperty('top','clamp(44px, var(--dk-favorites-top, 28vh), calc(100dvh - 64px))','important');
      tab.setAttribute('title','Favoritos guardados');
      tab.setAttribute('aria-label','Ver favoritos guardados');
      enableVerticalDrag(tab);
    }

    /* Dos frames garantizan que fondo, icono y contador ya tengan su estilo
       definitivo antes de mostrarse: elimina el flash "corazón primero". */
    window.requestAnimationFrame(function(){
      window.requestAnimationFrame(function(){
        document.documentElement.classList.add('dk-wish-ready');
      });
    });
  }

  function boot(){
    stabilizeFavorites();
  }

  /* defer suele ejecutar con readyState=interactive; este fallback cubre
     cualquier forma de carga sin permitir que el legacy llegue primero. */
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',boot,{once:true,capture:true});
  }else{
    boot();
  }
})();
